/** Site-wide branding (Open Arms Healthcare Services LLC — from project brief) */
export const SITE_NAME = 'Open Arms Healthcare Services LLC';
export const SITE_NAME_SHORT = 'Open Arms Healthcare Services';
export const SITE_URL = 'https://openarmshealthcareservices.com';

export const SITE_TAGLINE =
  'Quality healthcare that is accessible, convenient, and affordable—delivered through telehealth, wherever you are.';

export const DEFAULT_SEO_DESCRIPTION =
  'Open Arms Healthcare Services LLC is a telehealth provider offering non-emergent sick visits, medication refills, lab orders with interpretation, weight loss support, chronic condition education, and smoking cessation—with transparent, affordable pricing.';

export const DEFAULT_SEO_KEYWORDS =
  'telehealth, virtual doctor, online healthcare, sick visit, medication refill, lab orders, chronic care, weight loss, smoking cessation, affordable healthcare';
